<template>
	<slot :expanded="isExpanded" :toggleExpanded="toggle" :expandText="expandText"></slot>
</template>

<script setup>
import { ref, watch } from 'vue'

const isExpanded = ref(false);

const toggle = () => {
	isExpanded.value = !isExpanded.value;
};

const expandText = ref('Read More')

watch(isExpanded, (newValue) => {
	setTimeout(() => {
		expandText.value = newValue ? 'Read Less' : 'Read More'
	}, 300)
})

</script>
